module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/mena-kazerounian-209e4cbc243217704a501a2cf084693a.jpg";